export default __webpack_public_path__ + "static/media/rocket.286676b1.gif";